// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"c50d8a5e","outerContainer":"_7e285340","secondaryToolbar":"_52abddf9","doorHangerRight":"_6c40bdf6","toolbarContainer":"f157f795","toolbarViewerMiddle":"a33775b5","progressBar":"_73d81050","back-to-application":"_63bd6544","wrapper":"d26880cb","documentWrapper":"_16bc3ec9","icon":"_4f602c37","image":"f88366e5","removeIcon":"_8f59c816","fileTitle":"e32d0a6e","fileCategory":"_6a2cb470"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileLayout/ProfileDocumentation/AttachmentItem/index.styl
// module id = 5085
// module chunks = 39